import React, { useState, useEffect, useContext, Fragment } from "react";
import { Button } from "react-bootstrap";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import ListFilters from "components/sales/ListFilters/ListFilters";
import { toast } from "react-toastify";

const ActiveReactivateList = ({
  getoffRoleEmployeesData,
  getEmployeesListing = [],
  getDataForDropdown,
  getDropdownDatas = [],
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);

  const Headers = [
    "Employee ID",
    "Department",
    "Employee Name",
    "Request Date",
    "Approval Date",
    "Joining Date",
    "Vendor",
    "Employee Type",
    "Location",
    "Status",
    "Action",
  ];

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const res = await getoffRoleEmployeesData(1, [3, 4]);
      await getDataForDropdown();
      setIsLoading(false);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const tableData = [
      "employee_code",
      "department_name",
      "name",
      "requested_date",
      "action_date",
      "date_of_joining",
      "vendor_name",
      "employee_type_name",
      "city_name",
      "user_status_name",
    ];

    setListData();

    if (
      getEmployeesListing &&
      getEmployeesListing?.response?.data &&
      getEmployeesListing?.response?.data?.data
    ) {
      const data = getEmployeesListing?.response?.data?.data?.map((element) => {
        let actions = [];

        if (
          element.status == 3 ||
          element.status == 4 ||
          element.user_status == 1 ||
          element.user_status == 2
        ) {
          actions.push({
            name: "On-board/Off-board",
            link: `${baseUrl}/active-inactive-employee/${element.user_id}`,
          });

          if (element.status == 3 || element.user_status == 1) {
            actions.push({
              name: "Update",
              link: `${baseUrl}/update-request/${element.user_id}`,
            });
          }
        }

        return Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Action: actions,
          }
        );
      });

      if (data) setListData(data);
      setPageCount(
        Math.ceil(
          getEmployeesListing?.response?.data?.total /
            getEmployeesListing?.response?.data?.to
        )
      );
    }
  }, [getEmployeesListing]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    localStorage.setItem("getoffRoleEmployeesData", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    const res = await getoffRoleEmployeesData(1, [3, 4], null, filterData);
    if (res?.data?.response_status !== 200) {
      toast.error(res?.data?.message);
    }
    setIsLoading(false);
    filterToggle();
  };

  const headerBtns = () => (
    <Fragment>
      <Button
        onClick={filterToggle}
        className="filter-hamburger filter-btn btn btn-transparent"
      >
        <img src={Images?.Filter} alt="" />
        {localization.showFilters}
      </Button>
    </Fragment>
  );

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    const res = await getoffRoleEmployeesData(
      val.selected + 1,
      [3, 4],
      null,
      filter
    );
    if (res?.data?.response_status !== 200) {
      toast.error(res?.data?.message);
    }
    localStorage.setItem("page", val.selected + 1);
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.offroleEmployee}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        headers={Headers}
        pageCount={pageCount}
        onPageChange={onPageChange}
        detailList={
          getEmployeesListing &&
          getEmployeesListing?.response &&
          getEmployeesListing?.response?.data &&
          getEmployeesListing?.response?.data?.data
        }
        srNo={getEmployeesListing?.response?.data?.from}
      />
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        offroleEmployeeFilter={true}
        getDropdownDatas={getDropdownDatas}
        activeInactive
      />
    </Layout>
  );
};

export default ActiveReactivateList;
